import { createPaginatedSlice } from '../../helpers/reduxHelper';

const tickets = createPaginatedSlice('tickets', {
  defaultState: {
    openedTicket: null,
  },
  reducers: {
    setOpenedTicket: (state, { payload }) => {
      state.openedTicket = payload.openedTicket;
    },
    resetOpenedTicket: (state) => {
      state.openedTicket = null;
    },
  },
});

export const ticketsActions = tickets.actions;
export const ticketsSelector = (state) => state.tickets;
export const ticketsReducer = tickets.reducer;
export default ticketsReducer;

export const ticketsSelectors = tickets.LF.selectors;
